import { render } from "./IconDocumentList.vue?vue&type=template&id=bf5e7846"
const script = {}
script.render = render

export default script